<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        label-width="180px"
        @cancle="cancleHandler"
        @submit="submitHandler"
        >
            <el-form-item
            class="table-full-row"
            label="邀请书名称"
            prop="yqsname"
            :rules="newRule('邀请书名称', 'required')">
                <el-input v-model="form.yqsname"></el-input>
            </el-form-item>

            <el-form-item
            label="招标项目名称"
            >
                {{form.zbproname}} 
            </el-form-item>

            <el-form-item
            label="项目编码"
            >
                {{form.zbprocode}}
            </el-form-item>

            <el-form-item
            label="标段名称"
            prop="bdcode"
            :rules="newRule('标段名称', 'required')">
                <cascader-bid
                    v-model="form.bdcode"
                    2way="name"
                    :name.sync="form.bdname"
                    :isXt="isXt"
                    :zbprocode="form.procode"
                ></cascader-bid>
            </el-form-item>

            <el-form-item
            label="标段编码"
            >
                 <div class="bdcode-item">
                     {{form.bdcode || '-'}}
                </div>
            </el-form-item>

            <el-form-item
            label="邀请单位名称"
            prop="yqdwname"
            :rules="newRule('邀请单位名称', 'required')" v-if="this.isXt==1">
                <select-dw
                    :isXt="isXt"
                    :zgys="form.zgys"
                    :bdcodes="form.bdcode"
                    :yqdwcode="form.yqdwcode"
                    :disabled="!form.bdcode"
                    v-model="form.yqdwcode"
                    2way="dwcnname" 
                    :dwcnname.sync="form.yqdwname"
                    :procode="detailExtra.procode"
                    multiple
                    model-str
                ></select-dw>
            </el-form-item>

            <el-form-item
            label="邀请单位名称"
            prop="yqdwname"
            :rules="newRule('邀请单位名称', 'required')" v-if="!this.form.zgys&&(this.isXt==0||this.isXt==undefined)">
                <select-dw
                    :isXt="isXt"
                    :zgys="form.zgys"
                    :bdcodes="form.bdcode"
                    :yqdwcode="form.yqdwcode"
                    :disabled="!form.bdcode"
                    v-model="form.yqdwcode"
                    2way="dwcnname" 
                    :dwcnname.sync="form.yqdwname"
                    :procode="detailExtra.procode"
                    multiple
                    model-str
                ></select-dw>
            </el-form-item>

            <el-form-item
            label="邀请单位名称"
            prop="yqdwname"
            :rules="newRule('邀请单位名称', 'required')" v-if="this.form.zgys&&(this.isXt==0||this.isXt==undefined)">
                <cascader-dw
                    :isXt="isXt"    
                    :zgys="form.zgys"
                    :bdcodes="form.bdcode"
                    :yqdwcode="form.yqdwcode"
                    :disabled="!form.bdcode"
                    v-model="form.yqdwcode"
                    2way="tbdwname" 
                    :tbdwname.sync="form.yqdwname"
                    :procode="detailExtra.procode"
                    multiple
                    model-str
                ></cascader-dw>
            </el-form-item>

            <el-form-item
            label="邀请单位编码"
            >
                <div style="word-break:break-all;">
                    {{form.yqdwcode || '-'}} 
                </div>
            </el-form-item>

            <el-form-item
            label="文件获取时间"
            prop="wjhqtime"
            :rules="newRule('文件获取时间', 'required')">
                <el-date-picker
                    v-model="form.wjhqtime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :picker-options="expireTimeOption"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item
            label="文件获取方法/平台地址"
            prop="wjhqff"
            :rules="newRule('文件获取方法/平台地址', 'required')">
                <el-input v-model="form.wjhqff"></el-input>
            </el-form-item>

            <el-form-item
            label="文件递交截止时间"
            prop="wjdjjztime"
            :rules="newRule('文件递交截止时间', 'required')">
                <el-date-picker
                    v-model="form.wjdjjztime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :picker-options="expireTimeOption"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item
            label="文件递交方法/平台地址"
            prop="wjdjff"
            :rules="newRule('文件获取方法/平台地址', 'required')">
                <el-input v-model="form.wjdjff"></el-input>
            </el-form-item>

            <el-form-item
            label="回函截止时间"
            prop="hhjztime"
            :rules="newRule('回函截止时间', 'required')">
                <el-date-picker
                    v-model="form.hhjztime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :picker-options="expireTimeOption"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item
            label="投标资格"
            prop="tbzg"
            :rules="newRule('投标资格', 'required')">
                <el-input v-model="form.tbzg"></el-input>
            </el-form-item>

            <el-form-item
            class="table-full-row"
            label="公告内容"
            prop="ggcontent" 
            >
                <ueditor v-model="form.ggcontent"></ueditor>
            </el-form-item>

            <el-form-item
            label="附件"
            class="table-full-row"
            >
                <my-upload
                :file-guid="form.fileguid"
                ></my-upload>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button
                @click="saveHandler(1, scope.submitHandler)"
                type="primary"
                icon="el-icon-circle-check">
                    提交 
                </el-button>
                <el-button
                @click="saveHandler(0, scope.submitHandler)"
                type="warning"
                icon="el-icon-remove-outline">
                    保存
                </el-button>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_LIST_PAGE from '@views/mixins/dialog-list-page'
import CascaderBid from './components/cascader-bid'
import SelectDw from './components/select-dw' 
import CascaderDw from './components/cascader-dw' 
export default {
    mixins: [DIALOG_LIST_PAGE, FORM_PAGE_MIXIN],
    components: { CascaderBid, SelectDw,CascaderDw},
    data: () => ({
        form: {
            zgys:"",
            zbprocode:'',
            bdname:'',
            bdcode:'',
            procode:'',
            yqdwcode:'',
            yqdwname:''
        },
        isXt:'',  
        expireTimeOption: {
            disabledDate(date) {
                return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
            }
        }   
    }),
    methods: {
        saveHandler:function(id,cb){           
            this.form.shbj=id;
            cb()
        },
        submitHandler:function(){
            var that=this
            if(this.isXt==0||this.isXt==undefined) {
                that.$post(`${this.getGetters('bidUrl')}/FangAn/TbYqs/add.json`,
                this.form, (data, res) => {
                    ShowMsg(res.msg,'success');
                    this.cancleHandler();
                });
            }
            if(this.isXt==1) {
                that.$post(`${this.getGetters('bidUrl')}/FangAn/TbYqs/xingtai/add.json`,
                this.form, (data, res) => {
                    ShowMsg(res.msg,'success');
                    this.cancleHandler();
                });
            }
        },
    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/FangAn/TbYqs/edit.json`, this.detailExtra, data => {
            var form = data.model;
            form.zgys = data.zgys;
            console.log(data.model)
            this.form = form;
            this.isXt=this.getQuery('isXt')
            console.log(!this.form.zgys&&(this.isXt==0||this.isXt==undefined))
            this.form.procode=data.procode
        });    
    }
}
</script>

<style scoped lang="scss">
 .bdcode-item {
    word-break: break-all;
    white-space: pre-wrap;
}
</style>
